var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.visible)?_c('div',{staticClass:"mod-black-tip",style:({maxWidth: `${_vm.maxWidth}px`})},[_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.msgText))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }